import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useUserSettings } from '../../contexts/UserSettingsContext';
import { printNextOrder } from '../../services/shipStationAPI';
import { getApiErrorMessage } from '../../services/errorUtils';
import './OrdersPilot.css';

function OrdersPilot(): React.ReactElement {
  const navigate = useNavigate();
  const { settings } = useUserSettings();
  const [printStatus, setPrintStatus] = useState<string | null>(null);
  const [printError, setPrintError] = useState<string | null>(null);
  const [printing, setPrinting] = useState(false);

  const handlePickNext = (): void => {
    navigate('/pick-next-order');
  };

  const handleMyOrders = (): void => {
    navigate('/my-orders');
  };

  const handleAllOrders = (): void => {
    navigate('/orders-list');
  };

  const handleSingleSkuOrders = (): void => {
    navigate('/single-sku-orders');
  };

  const handleClaimOrder = (): void => {
    navigate('/claim-order');
  };

  const handlePrintNext = async (): Promise<void> => {
    setPrinting(true);
    setPrintStatus(null);
    setPrintError(null);
    try {
      const result = await printNextOrder();
      setPrintStatus(`Printed label for order #${result.orderNumber}`);
    } catch (err: unknown) {
      if (axios.isAxiosError(err) && err.response?.status === 404) {
        setPrintError('No orders available');
      } else if (axios.isAxiosError(err) && err.response?.data && typeof err.response.data === 'object') {
        const body = err.response.data as { error?: string };
        setPrintError(body.error ?? getApiErrorMessage(err, 'Failed to print next order'));
      } else {
        setPrintError(getApiErrorMessage(err, 'Failed to print next order'));
      }
    } finally {
      setPrinting(false);
    }
  };

  const showPrintClaimFlow = settings.printScanOrderLabel;

  return (
    <div className="home-container">
      {showPrintClaimFlow ? (
        <>
          <button
            className="home-button"
            onClick={() => { void handlePrintNext(); }}
            disabled={printing}
            type="button"
          >
            {printing ? 'Printing…' : 'Print Next Order'}
          </button>
          {printStatus ? (
            <p className="orders-pilot-status orders-pilot-status--success" role="status">
              {printStatus}
            </p>
          ) : null}
          {printError ? (
            <p className="orders-pilot-status orders-pilot-status--error" role="alert">
              {printError}
            </p>
          ) : null}
          <button className="home-button" onClick={handleClaimOrder} type="button">
            Claim Order
          </button>
        </>
      ) : null}
      <button className="home-button" onClick={handlePickNext} type="button">
        Pick Next Order
      </button>
      <button className="home-button" onClick={handleMyOrders} type="button">
        My Orders
      </button>
      <button className="home-button" onClick={handleAllOrders} type="button">
        All Orders
      </button>
      <button className="home-button" onClick={handleSingleSkuOrders} type="button">
        Batch Orders
      </button>
    </div>
  );
}

export default OrdersPilot;
